<template>
<div>
  <v-dialog v-model="dialog" width="550" persistent>
    <v-card>
      <v-card-title>{{ $t('fleet.searchReload') }}</v-card-title>
      <v-card-text>
        <div v-if="roads.length > 0">
          <label>{{ $t("fleet.roads.selectRoad") }}</label>
          <v-select
            v-model="selectedRoad"
            @change="roadChange"
            :items="roads"
            :item-text="
              (item) =>
                item.firstLoading +
                ' - ' +
                item.lastUnloadng +
                ' (' +
                item.pointsCounter +
                ')'
            "
            item-value="id"
            dense
            outlined
          ></v-select>
        </div>
        <div v-else class="text-center py-4">
          <p class="text-subtitle-1 mb-4">{{ $t("fleet.roads.noRoadsAvailable") }}</p>
          <v-btn
            color="primary"
            @click="addRoad"
            depressed
          >
            {{ $t("fleet.roads.addRoad") }}
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn
          :loading="loading"
          :disabled="loading || !selectedRoad"
          color="primary"
          @click="send"
          depressed
        >
          {{ $t('common.save') }}
        </v-btn>
        <v-btn
          :loading="loading"
          :disabled="loading"
          outlined
          @click="close"
          depressed
        >
          {{ $t('common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import Service from '@/services'
import {
  DATETIME
} from '@/types/filter-value-types'
import { convertFilters } from '@/utils/market'
import {
  MAX,
  MIN
} from '@/types/condition-types'

export default {
  data () {
    return {
      roads: [],
      selectedRoad: null,
      dialog: false,
      loading: false,
      item: null,
      roadDetails: null
    }
  },
  methods: {
    async roadChange (id) {
      if (!id) return

      try {
        const { data } = await Service.get('road/GetDetails', {
          roadId: id
        })
        this.roadDetails = data
      } catch (e) {
        console.error('Error loading road details:', e)
      }
    },
    async open (item) {
      this.dialog = true
      this.item = item

      try {
        const { data } = await Service.get('road/getroad', {
          vehicleId: item.id
        })
        this.roads = data.results
      } catch (e) {
        console.error('Error loading roads:', e)
        this.roads = []
      }
    },
    close () {
      this.roads = []
      this.item = null
      this.dialog = false
      this.selectedRoad = null
      this.roadDetails = null
    },
    async send () {
      if (!this.selectedRoad || !this.roadDetails) {
        return
      }

      this.loading = true

      try {
        // var first  = this.roadDetails.places[data.places.length - 1].location
        // var last = this.roadDetails.places[0].location
        var dateFrom = {
          type: MIN,
          name: 'Start',
          valueType: DATETIME,
          value: this.roadDetails.places[0].dateTime
        }
        var dateTo = {
          type: MAX,
          name: 'Start',
          valueType: DATETIME,
          value: this.roadDetails.places[this.roadDetails.places.length - 1].dateTime
        }
        console.log(this.roadDetails)

        var l = JSON.parse(JSON.stringify(this.roadDetails.places.filter(x => x.type === 0)))
        var ul = JSON.parse(JSON.stringify(this.roadDetails.places.filter(x => x.type === 1)))
        const conditions = {
          minStart: dateFrom,
          maxStart: dateTo,
          locations: {
            type: 17,
            loadingPlaces: l.map(i => ({
              ...i.location
            })),
            unloadingPlaces: ul.map(i => ({
              ...i.location
            }))
          }
        }

        console.log(conditions)
        const filters = convertFilters(this.$store.getters['market/orderType'], conditions)
        const { data } = await Service.post('Filter/CreateForVehicle', {
          vehicleId: this.item.id,
          conditions: filters.conditions,
          isReload: true
        })

        this.$router.push({
          name: 'ReloadsFilter',
          params: {
            id: data
          }
        })
      } catch (e) {
        console.error('Error creating reload filter:', e)
      } finally {
        this.loading = false
      }
    },
    async addRoad () {
      if (!this.item) {
        return
      }

      this.loading = true
      try {
        const { data } = await Service.get('road/getroad', { vehicleId: this.item.id })
        if (data.count > 5) {
          await this.$store.dispatch('setErrorNotification', this.$t('fleet.roads.roadsLimit'))
          return
        }
      } catch (e) {
        console.error('Error checking roads limit:', e)
      } finally {
        this.loading = false
      }

      this.$router.push({ name: 'AddRoad', params: { id: this.item.id } })
      this.close()
    }
  }
}
</script>

<style></style>
